import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { PageHeader, EmptyState, Loading, Card, StatCard } from "../../components/common";
import { api } from "../../lib/api";
import { pkr, fmtDate, PAY_METHODS } from "../../lib/format";

export default function PaymentHistory() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/payments/mine").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loading />;
  const total = items.reduce((s, p) => s + p.amount, 0);
  return (
    <div>
      <PageHeader title="Payment History" subtitle="Commission payments recorded by the administrator." />
      <div className="mb-6 grid grid-cols-2 gap-4 sm:max-w-md">
        <StatCard testid="payments-total" label="Total received" value={pkr(total)} tone="green" />
        <StatCard label="Payments" value={items.length} />
      </div>
      {items.length === 0 ? <EmptyState icon={Receipt} title="No payments yet" message="When the administrator pays your approved commissions, the payment details will appear here." /> : (
        <div className="space-y-3">
          {items.map((p) => (
            <Card key={p.id} className="p-5" data-testid={`payment-card-${p.reference}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div><p className="font-mono text-xl font-bold text-emerald-700">{pkr(p.amount)}</p><p className="text-sm text-slate-600">{PAY_METHODS[p.method]} · Ref <span className="font-mono">{p.reference}</span></p></div>
                <p className="text-sm text-slate-500">{fmtDate(p.paid_at)}</p>
              </div>
              <p className="mt-3 text-xs text-slate-500">Orders: <span className="font-mono">{p.order_nos.join(", ")}</span></p>
              {p.notes && <p className="mt-1 text-sm text-slate-600">{p.notes}</p>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
